module.exports = __webpack_public_path__ + "static/media/Aditya_Birla_Sun_Life_Mutual_Fund.9dce312c.pdf";